import { createIcon } from '@chakra-ui/icons';

export const FileCopies = createIcon({
  displayName: 'FileCopies',
  viewBox: '0 0 14 14',
  path: [
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.08333 8.16638H2.33333C2.01117 8.16638 1.75 7.90522 1.75 7.58305V3.60251C1.75 3.44367 1.81477 3.2917 1.92936 3.1817L3.85935 1.3289C3.96799 1.22462 4.11274 1.16638 4.26333 1.16638H7C7.32218 1.16638 7.58333 1.42755 7.58333 1.74972V3.35388"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M6.41732 10.4996H4.66732C4.34515 10.4996 4.08398 10.2385 4.08398 9.9163V5.93575C4.08398 5.77692 4.14876 5.62495 4.26334 5.51495L6.19332 3.66216C6.30199 3.55787 6.44672 3.49963 6.59733 3.49963H9.33398C9.65616 3.49963 9.91732 3.7608 9.91732 4.08297V5.83297"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M8.92937 5.83313H11.666C11.9882 5.83313 12.2493 6.09429 12.2493 6.41646V12.2498C12.2493 12.572 11.9882 12.8331 11.666 12.8331H6.99935C6.67717 12.8331 6.41602 12.572 6.41602 12.2498V8.26925C6.41602 8.1104 6.48077 7.95845 6.59539 7.84843L8.52535 5.99565C8.63402 5.89135 8.77875 5.83313 8.92937 5.83313Z"
        stroke="#6D6D6D"
        strokeWidth="1.16667"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>,
  ],
});
